 
    <style scoped>
        
        .container {
            width: 100%;
            max-width: 400px;
        }
        
        /* 卡片样式 */
        .card {
            background: white;
            border-radius: 16px;
            padding: 25px 20px;
            margin-bottom: 20px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
        }
        .card-title {
            font-size: 18px;
            font-weight: 600;
            color: #3498db;
            margin-bottom: 20px;
            text-align: center;
        }
        
        /* 表单样式 */
        .form-group {
            margin-bottom: 20px;
        }
        .form-label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
            color: #555;
        }
        .form-input {
            width: 90%;
            padding: 12px 15px;
            border: 1px solid #ddd;
            border-radius: 8px;
            font-size: 16px;
        }
        .form-input:focus {
            border-color: #3498db;
            outline: none;
            box-shadow: 0 0 0 2px rgba(52,152,219,0.2);
        }
        
        /* 优化后的激活码输入框 */
        .code-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }
        .code-input {
            width: 45px;
            height: 50px;
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            border: 2px solid #ddd;
            border-radius: 8px;
            transition: all 0.3s;
        }
        .code-input:focus {
            border-color: #3498db;
            outline: none;
            box-shadow: 0 0 0 2px rgba(52,152,219,0.2);
            transform: scale(1.05);
        }
        
        /* 按钮样式 */
        .btn {
            padding: 15px;
            border-radius: 10px;
            border: none;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s;
            width: 100%;
        }
        .btn-primary {
            background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%);
            color: white;
        }
        .btn-primary:hover {
            opacity: 0.9;
            transform: translateY(-2px);
        }
        
        /* 消息提示 */
        .message {
            padding: 12px 15px;
            border-radius: 8px;
            margin-bottom: 20px;
            text-align: center;
            font-weight: 500;
        }
        .message-success {
            background: #e8f6f0;
            color: #2ecc71;
            border: 1px solid #2ecc71;
        }
        .message-error {
            background: #feecf0;
            color: #e74c3c;
            border: 1px solid #e74c3c;
        }
        
        /* 步骤指示器 */
        .steps {
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;
            position: relative;
        }
        .steps:before {
            content: '';
            position: absolute;
            top: 15px;
            left: 0;
            right: 0;
            height: 2px;
            background: #e0e0e0;
            z-index: 1;
        }
        .step {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: #e0e0e0;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: 500;
            position: relative;
            z-index: 2;
        }
        .step.active {
            background: #3498db;
        }
        .step.completed {
            background: #2ecc71;
        }
        .step-label {
            position: absolute;
            top: 35px;
            left: 50%;
            transform: translateX(-50%);
            white-space: nowrap;
            font-size: 12px;
            color: #666;
        }
        .step.active .step-label {
            color: #3498db;
            font-weight: 500;
        }
    </style>
 
    <template  >
        <div class="container">
            <!-- 步骤指示器 -->
            <div class="steps">
                <div class="step" :class="{ active: currentStep === 1, completed: currentStep > 1 }">
                    1
                    <div class="step-label">卡号验证</div>
                </div>
                <div class="step" :class="{ active: currentStep === 2, completed: currentStep > 2 }">
                    2
                    <div class="step-label">信息登记</div>
                </div>
                <div class="step" :class="{ active: currentStep === 3 }">
                    3
                    <div class="step-label">完成</div>
                </div>
            </div>
            
            <!-- 卡号验证 -->
            <div class="card" v-if="currentStep === 1">
                <div class="card-title">储存卡激活</div>
                
                <div class="form-group">
                    <label class="form-label">卡号</label>
                    <input type="text" class="form-input" v-model="cardNumber" readonly>
                </div>
                
                <div class="form-group">
                    <label class="form-label">激活码</label>
                    <div class="code-container">
                        <input type="text" class="code-input" maxlength="1" v-model="activationCode[0]" @input="focusNext(0)" ref="code0">
                        <input type="text" class="code-input" maxlength="1" v-model="activationCode[1]" @input="focusNext(1)" ref="code1">
                        <input type="text" class="code-input" maxlength="1" v-model="activationCode[2]" @input="focusNext(2)" ref="code2">
                        <input type="text" class="code-input" maxlength="1" v-model="activationCode[3]" @input="focusNext(3)" ref="code3">
                        <input type="text" class="code-input" maxlength="1" v-model="activationCode[4]" @input="focusNext(4)" ref="code4">
                        <input type="text" class="code-input" maxlength="1" v-model="activationCode[5]" @input="focusNext(5)" ref="code5">
                    </div>
                </div>
                
                <div class="message" :class="messageClass" v-if="showMessage">
                    {{ messageText }}
                </div>
                
                <button class="btn btn-primary" @click="verifyActivationCode">验证</button>
            </div>
            
            <!-- 权益人登记 -->
            <div class="card" v-if="currentStep === 2">
                <div class="card-title">储存权益人登记</div>
                
                <div class="form-group">
                    <label class="form-label">儿童姓名</label>
                    <input type="text" class="form-input" v-model="childInfo.name" placeholder="请输入儿童姓名">
                </div>
                
                <div class="form-group">
                    <label class="form-label">性别</label>
                    <div style="display: flex; gap: 15px;">
                        <div style="flex: 1; display: flex; align-items: center; justify-content: center; padding: 12px; border: 1px solid #ddd; border-radius: 8px; cursor: pointer;"
                            :style="{ borderColor: childInfo.gender === 'male' ? '#3498db' : '#ddd', background: childInfo.gender === 'male' ? '#e8f4fc' : 'white', color: childInfo.gender === 'male' ? '#3498db' : '#333' }"
                            @click="childInfo.gender = 'male'">男</div>
                        <div style="flex: 1; display: flex; align-items: center; justify-content: center; padding: 12px; border: 1px solid #ddd; border-radius: 8px; cursor: pointer;"
                            :style="{ borderColor: childInfo.gender === 'female' ? '#3498db' : '#ddd', background: childInfo.gender === 'female' ? '#e8f4fc' : 'white', color: childInfo.gender === 'female' ? '#3498db' : '#333' }"
                            @click="childInfo.gender = 'female'">女</div>
                    </div>
                </div>
                
                <div class="form-group">
                    <label class="form-label">儿童证件类型</label>
                    <select class="form-input" v-model="childInfo.idType">
                        <option value="">请选择证件类型</option>
                        <option value="idCard">身份证</option>
                        <option value="passport">护照</option>
                        <option value="birthCertificate">出生证明</option>
                        <option value="other">其他</option>
                    </select>
                </div>
                
                <div class="form-group">
                    <label class="form-label">儿童证件号码</label>
                    <input type="text" class="form-input" v-model="childInfo.idNumber" placeholder="请输入证件号码">
                </div>
                
                <div class="form-group">
                    <label class="form-label">监护人姓名</label>
                    <input type="text" class="form-input" v-model="guardianInfo.name" placeholder="请输入监护人姓名">
                </div>
                
                <div class="form-group">
                    <label class="form-label">监护人手机号</label>
                    <input type="tel" class="form-input" v-model="guardianInfo.phone" placeholder="请输入手机号码">
                </div>
                
                <div class="form-group">
                    <label class="form-label">验证码</label>
                    <input type="text" class="form-input" v-model="verificationCode" placeholder="请输入验证码">
                </div>
                
                <div class="message" :class="messageClass" v-if="showMessage">
                    {{ messageText }}
                </div>
                
                <button class="btn btn-primary" @click="activateCard">激活</button>
            </div>
            
            <!-- 激活成功 -->
            <div class="card" v-if="currentStep === 3">
                <div class="card-title">激活成功</div>
                
                <div style="text-align: center; margin: 30px 0;">
                    <div style="font-size: 60px; color: #2ecc71; margin-bottom: 20px;">
                        <i class="fas fa-check-circle"></i>
                    </div>
                    <p style="font-size: 16px; color: #666; margin-bottom: 30px;">
                        储存卡已成功激活，您可以开始使用爱乐存服务了。
                    </p>
                </div>
                
                <button class="btn btn-primary" @click="goToHome">返回首页</button>
            </div>
        </div>
    </template>

    <script>
        export default {
            name: 'Card',
            data(){return {
                currentStep: 1,
                cardNumber: '9901' + Math.floor(1000 + Math.random() * 9000),
                activationCode: ['', '', '', '', '', ''],
                correctActivationCode: 123456,
                childInfo: {
                    name: '',
                    gender: '',
                    idType: '',
                    idNumber: ''
                },
                guardianInfo: {
                    name: '',
                    phone: ''
                },
                verificationCode: '',
                showMessage: false,
                messageText: '',
                messageClass: ''
            }},
            mounted() {
                console.log('正确激活码:', this.correctActivationCode); // 用于测试
            },
            methods: {
                focusNext(index) {
                    if (this.activationCode[index] && index < 5) {
                        // 自动聚焦到下一个输入框
                        this.$refs['code' + (index + 1)][0].focus();
                    }
                },
                verifyActivationCode() {
                    const enteredCode = this.activationCode.join('');
                    
                    if (enteredCode.length !== 6) {
                        this.showMessage = true;
                        this.messageText = '请输入完整的6位激活码';
                        this.messageClass = 'message-error';
                        return;
                    }
                    
                    if (enteredCode === this.correctActivationCode) {
                        this.showMessage = true;
                        this.messageText = '验证成功';
                        this.messageClass = 'message-success';
                        
                        // 2秒后跳转到下一步
                        setTimeout(() => {
                            this.currentStep = 2;
                            this.showMessage = false;
                        }, 2000);
                    } else {
                        this.showMessage = true;
                        this.messageText = '验证失败，请联系客服处理';
                        this.messageClass = 'message-error';
                    }
                },
                activateCard() {
                    // 表单验证
                    if (!this.childInfo.name) {
                        this.showMessage = true;
                        this.messageText = '请输入儿童姓名';
                        this.messageClass = 'message-error';
                        return;
                    }
                    
                    if (!this.childInfo.gender) {
                        this.showMessage = true;
                        this.messageText = '请选择儿童性别';
                        this.messageClass = 'message-error';
                        return;
                    }
                    
                    if (!this.childInfo.idType) {
                        this.showMessage = true;
                        this.messageText = '请选择证件类型';
                        this.messageClass = 'message-error';
                        return;
                    }
                    
                    if (!this.childInfo.idNumber) {
                        this.showMessage = true;
                        this.messageText = '请输入证件号码';
                        this.messageClass = 'message-error';
                        return;
                    }
                    
                    if (!this.guardianInfo.name) {
                        this.showMessage = true;
                        this.messageText = '请输入监护人姓名';
                        this.messageClass = 'message-error';
                        return;
                    }
                    
                    if (!this.guardianInfo.phone) {
                        this.showMessage = true;
                        this.messageText = '请输入监护人手机号';
                        this.messageClass = 'message-error';
                        return;
                    }
                    
                    if (!this.verificationCode) {
                        this.showMessage = true;
                        this.messageText = '请输入验证码';
                        this.messageClass = 'message-error';
                        return;
                    }
                    
                    // 模拟验证码验证
                    if (this.verificationCode !== '123456') { // 假设正确验证码是123456
                        this.showMessage = true;
                        this.messageText = '验证码错误';
                        this.messageClass = 'message-error';
                        return;
                    }
                    
                    // 激活成功
                    this.showMessage = true;
                    this.messageText = '激活成功';
                    this.messageClass = 'message-success';
                    
                    // 2秒后跳转到完成页面
                    setTimeout(() => {
                        this.currentStep = 3;
                        this.showMessage = false;
                    }, 2000);
                },
                goToHome() {
                    alert('返回首页');
                    // 实际应用中：跳转到首页
                }
            }
        };
    </script>
 